import React from 'react';
import ControlPlaneLayout from './ControlPlaneLayout';

const TemplatesPage = () => {
  return (
    <ControlPlaneLayout
      eyebrow="Templates Page"
      title="Request templates"
      description="Reuse approved request structures for binary forecasts, scalar forecasts, private KPI reviews, and research-to-forecast workflows."
    />
  );
};

export default TemplatesPage;
